import React from "react";
import CookieAlertDom from "@/shared/components/cookie_alert";
import { createRoot } from "react-dom/client";

window.addEventListener("DOMContentLoaded", () => {
  // アラートを表示するのは一度のみ
  // 規約が変更されアラートを再度表示する場合は日付を変更してください
  const optIn = JSON.parse(localStorage.getItem("opt-in"));
  if (optIn && optIn.agreed === 202007) {
    return;
  }

  localStorage.setItem("opt-in", JSON.stringify({ agreed: 202007 }));
  const cookieAlert = document.getElementById("js-cookie_alert");
  // アラート表示
  if (cookieAlert) {
    const root = createRoot(cookieAlert);
    root.render(<CookieAlertDom />);
  }
});
